import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Card, CardHeader, Input, LoadingSpinner } from "@webtypen/react-components";
import { ApiHelper, ConfirmHelper } from "../helpers";
import { useSelector } from "react-redux";
import moment from "moment";

const ChatContent = styled.div`
    padding: 10px;
    height: 350px;
    max-height: 350px;
    overflow: auto;

    ${(props) =>
        props.centered
            ? `
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
    `
            : ``}
`;

const CommentWrapper = styled.div`
    display: flex;
    padding-top: 3px;
    padding-bottom: 3px;

    ${(props) => (props.isAuthUser ? `justify-content: flex-end;` : ``)}
`;

const Comment = styled.div`
    width: 80%;
    padding: 5px 8px;
    background: #eee;
    border-radius: 3px;

    .user {
        font-size: 12px;
        font-weight: 700;
    }
`;

export const CommentsBox = ({ title, channel, ...rest }) => {
    const contentRef = useRef(null);
    const auth = useSelector((state) => state.app.auth);
    const [isLoading, setIsLoading] = useState(true);
    const [isCreating, setIsCreating] = useState(false);
    const [comments, setComments] = useState(null);
    const [text, setText] = useState("");

    const load = () => {
        setIsLoading(true);
        ApiHelper.request("/api/comments/data", {
            channel: channel,
        })
            .then((response) => {
                setComments(
                    response.status === "success" && response.data && response.data.length > 0 ? response.data : null
                );
                setIsLoading(false);
            })
            .catch((e) => {
                console.error(e);
                setComments(null);
                setIsLoading(false);
            });
    };

    const onChange = (e) => {
        setText(e.target.value);
    };

    const scrollDown = () => {
        if (!contentRef || !contentRef.current) {
            return;
        }

        contentRef.current.scroll({
            top: contentRef.current.scrollHeight,
            behavior: "smooth",
        });
    };

    const submit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!text || text.trim() === "") {
            return;
        }

        setIsCreating(true);
        ApiHelper.request("/api/comments/create", {
            channel: channel,
            text: text.trim(),
        })
            .then((response) => {
                if (response.status === "success") {
                    setText("");
                } else {
                    ConfirmHelper.alert(
                        response.status === "error" && response.message && response.message.trim() !== ""
                            ? response.message
                            : "Es ist ein unerwarteter Fehler aufgetreten ..."
                    );
                }
                load();
                setIsCreating(false);
            })
            .catch((e) => {
                console.error(e);

                ConfirmHelper.alert(
                    e && e.data && e.data.status === "error" && e.data.message && e.data.message.trim() !== ""
                        ? e.data.message
                        : "Es ist ein unerwarteter Fehler aufgetreten ..."
                );
                load();
                setIsCreating(false);
            });
    };

    useEffect(() => {
        if (comments && comments.length > 0) {
            scrollDown();
        }
    }, [comments]);

    useEffect(() => {
        load();
    }, []);

    return (
        <Card {...rest}>
            {title ? <CardHeader>{title}</CardHeader> : null}
            {isLoading || !comments || comments.length < 1 ? (
                <ChatContent centered>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <div style={{ opacity: 0.5 }}>Es wurden noch keine Kommentare erstellt ...</div>
                    )}
                </ChatContent>
            ) : (
                <ChatContent ref={contentRef}>
                    {comments.map((comment, i) => (
                        <CommentWrapper isAuthUser={auth._id === comment.created_by} key={i}>
                            <Comment isAuthUser={auth._id === comment.created_by}>
                                <div className="user">
                                    {comment.user.firstname} {comment.user.lastname} -{" "}
                                    {moment(comment.created_at).fromNow()}
                                </div>
                                <div className="text">{comment.text}</div>
                            </Comment>
                        </CommentWrapper>
                    ))}
                </ChatContent>
            )}
            <form onSubmit={submit}>
                <div style={{ width: "100%", display: "flex", flexDirection: "row", borderTop: "1px solid #eee" }}>
                    <Input
                        type="text"
                        style={{ flex: 1, border: "none", borderRadius: 0 }}
                        value={text ? text : ""}
                        onChange={onChange}
                        disabled={isLoading || isCreating}
                        placeholder="Neuen Kommentar verfassen ..."
                    />
                </div>
            </form>
        </Card>
    );
};
